import { render, staticRenderFns } from "./christmas-faq.vue?vue&type=template&id=059f0606"
import script from "./christmas-faq.vue?vue&type=script&lang=js"
export * from "./christmas-faq.vue?vue&type=script&lang=js"
import style0 from "./christmas-faq.vue?vue&type=style&index=0&id=059f0606&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports